import { useTranslations } from 'next-intl';
import { FormEvent, ReactNode, useState } from 'react';
import Modal from 'react-modal';
import { Button } from '../../../../../../components/design-system';
import {
  Close as IconClose,
  Search as IconSearch,
} from '../../../../../../components/icons';
import { useToggle } from '../../../../../../hooks';
import SearchResult from './SearchResult';

interface RenderTriggerArgs {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

interface Props {
  renderTrigger: (args: RenderTriggerArgs) => ReactNode;
}

const customStyle = {
  overlay: {
    zIndex: 999,
    backgroundColor: 'rgb(0 0 0 / 20%)',
  },
};

export default function SearchModal({ renderTrigger }: Props) {
  const t = useTranslations('shop');
  const { isOpen, open, close } = useToggle();
  const [q, setQ] = useState('');

  function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
  }

  return (
    <>
      {renderTrigger({ isOpen, open, close })}
      <Modal
        isOpen={isOpen}
        onRequestClose={(e) => {
          e.preventDefault();
          close();
        }}
        style={customStyle}
        className={`
          absolute bg-white p-0
          inset-x-0 top-10 bottom-0 sm:inset-x-32 sm:inset-y-auto sm:top-32
          sm:max-w-2xl sm:max-h-[650px] sm:mx-auto
          flex flex-col
          border-t sm:border-none border-greyscale-separator rounded-t-2xl sm:rounded-b-2xl
        `}
      >
        <form
          className="flex items-center px-3 h-14 border-b border-greyscale-separator shrink-0"
          onSubmit={handleSubmit}
        >
          <div className="shrink-0">
            <IconSearch className="text-greyscale-placeholder" />
          </div>
          <input
            autoFocus
            className="flex-1 form-input h-full text-base font-medium tracking-tight text-greyscale-body placeholder:text-greyscale-placeholder border-none focus:ring-transparent"
            placeholder={t('search.title')}
            onChange={(e) => setQ(e.target.value)}
            value={q}
          />
          <Button
            className="shrink-0"
            onClick={(e) => {
              e.preventDefault();
              setQ('');
              close();
            }}
            palette="gray"
            theme="ghost"
            type="button"
            variant="icon"
          >
            <IconClose className="" />
          </Button>
        </form>
        <div className="flex-1 overflow-y-auto">
          <SearchResult q={q} onChangeQ={setQ} onSelectSuggestion={close} />
        </div>
      </Modal>
    </>
  );
}
